export enum OrderSituacion {
  ESPERA_PAGO = 'En espera de Pago',
  PAGADO = 'Pagado',
  PAGO_DIFERIDO = 'Pago Diferido',
  PREPARACION = 'En preparación',
  ESPERA_ENTREGA = 'En espera de entrega',
  ENTREGADO = 'Entregado',
  CANCELADO = 'Cancelado'
}

export enum OrderEstado {
  CERRADO = 'Cerrado',
  ABIERTO = 'Abierto'
}
